<template>
  <article class="profile">
    <section class="profile__account">
      <form @submit.prevent="update"
            @keydown="form.onKeydown($event)"
            data-vv-scope="account"
            class="account-form form">
        <div class="form__field">
          <label class="form__label">Фото/аватар</label>

          <div class="form__input-wrapper">
            <div class="image-upload">
              <div class="image-upload__input-wrapper">
                <picture-input
                  ref="pictureInput"
                  @change="imageSelected('photo_url')"
                  width="200"
                  height="200"
                  margin="0"
                  accept="image/jpeg,image/png,image/svg"
                  size="10"
                  buttonClass="btn"
                  :customStrings="{
                  drag: 'Перетащите сюда изображение'
                }">
                </picture-input>
              </div>
              <div v-if="form.photo_url && form.photo_url.indexOf('/images/') !== -1" class="image-upload__image-wrapper">
                <img class="image-upload__image" :src="form.photo_url" />
                <button class="image-upload__button image-upload__button--remove form__button button button--blue" @click.prevent="removeImage('photo_url')">×</button>
              </div>
              <div v-else class="image-upload__placeholder"></div>
            </div>
          </div>
        </div>

        <div class="form__field">
          <label class="form__label">Имя</label>
          <div class="form__input-wrapper">
            <input v-model="form.name"
                   v-validate="'required|min:3'"
                   type="text"
                   name="name"
                   autocomplete="off"
                   class="form__input"
                   :class="{'is-danger': errors.has('account.name') }">
            <span v-show="errors.has('account.name')" class="form__alert form__alert--error">{{ errors.first('account.name') }}</span>
          </div>
        </div>

        <div class="form__field">
          <label class="form__label">Почта</label>
          <div class="form__input-wrapper">
            <input v-model="form.email"
                   v-validate="'required|email'"
                   type="email"
                   name="email"
                   class="form__input"
                   :class="{'is-danger': errors.has('account.email') }">
            <span v-show="errors.has('account.email')" class="form__alert form__alert--error">{{ errors.first('account.email') }}</span>
          </div>
        </div>

        <div class="form__field">
          <label class="form__label">Телефон</label>
          <div class="form__input-wrapper">
            <input v-model="form.phone"
                   v-validate="'min:3'"
                   type="text"
                   name="phone"
                   class="form__input"
                   :class="{'is-danger': errors.has('account.phone') }">
            <span v-show="errors.has('account.phone')" class="form__alert form__alert--error">{{ errors.first('account.phone') }}</span>
          </div>
        </div>

        <div class="form__field">
          <label class="form__label">Страна</label>
          <div class="form__input-wrapper">
            <input v-model="form.country"
                   type="text"
                   name="country"
                   class="form__input"
                   :class="{'is-danger': errors.has('account.country') }">
            <span v-show="errors.has('account.country')" class="form__alert form__alert--error">{{ errors.first('account.country') }}</span>
          </div>
        </div>

        <div class="form__field">
          <label class="form__label">Город</label>
          <div class="form__input-wrapper">
            <input v-model="form.city"
                   type="text"
                   name="city"
                   class="form__input"
                   :class="{'is-danger': errors.has('account.city') }">
            <span v-show="errors.has('account.city')" class="form__alert form__alert--error">{{ errors.first('account.city') }}</span>
          </div>
        </div>

        <div class="form__field">
          <label class="form__label">Организация</label>
          <div class="form__input-wrapper">
            <input v-model="form.organization"
                   type="text"
                   name="organization"
                   class="form__input"
                   :class="{'is-danger': errors.has('account.organization') }">
            <span v-show="errors.has('account.organization')" class="form__alert form__alert--error">{{ errors.first('account.organization') }}</span>
          </div>
        </div>

        <div class="form__field">
          <label class="form__label">Специализация</label>
          <div class="form__input-wrapper">
            <input v-model="form.specialization"
                   type="text"
                   name="specialization"
                   class="form__input"
                   :class="{'is-danger': errors.has('account.specialization') }">
            <span v-show="errors.has('account.specialization')" class="form__alert form__alert--error">{{ errors.first('account.specialization') }}</span>
          </div>
        </div>

        <v-button  class="form__button button button--blue" type="submit" :disabled="form.busy" :loading="form.busy">Сохранить</v-button>
      </form>
    </section>
  </article>
</template>

<script>
import Form from 'vform';
import PictureInput from 'vue-picture-input';
import { mapGetters } from 'vuex';

export default {
  scrollToTop: false,

  metaInfo () {
    return { title: 'Настройки профиля' };
  },
  components: {
    PictureInput,
  },
  data: () => ({
    form: new Form({
      photo_url: '',
      name: '',
      email: '',
      phone: '',
      country: '',
      city: '',
      organization: '',
      specialization: '',
    })
  }),
  computed: mapGetters({
    user: 'auth/user',
  }),

  created () {
    // Fill the form with user data.
    this.form.keys().forEach(key => {
      this.form[key] = this.user[key];
    })
  },
  methods: {
    async removeImage (field) {
      const path = '/api/settings/images';
      const specialForm = new Form({
        image_name: this.form[field],
      });
      await specialForm.delete(path);
      this.form[field] = '';
      this.update();
    },
    async imageSelected (field) {
      const path = '/api/settings/images';
      const specialForm = new Form({
        image: this.$refs.pictureInput.file,
        old_image_name: '',
      });
      if (this.form.image) {
        specialForm['old_image_name'] = this.form[field];
      }
      const { data } = await specialForm.post(path);
      this.form[field] = data;
      this.update();
    },
    async update () {
      const { data } = await this.form.patch('/api/settings/profile');
      this.$alertify.success('Изменения сохранены');

      this.$store.dispatch('auth/updateUser', { user: data });
    },
  },
  beforeMount () {
    this.$store.dispatch('pages/setBreadcrumbs', [
      {
        title: 'Главная',
        route: { name: 'home' },
      },
      {
        title: 'Настройки профиля',
      }
    ]);
  }
}
</script>
